import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '!=': [
                {
                  '@': 'previewRiskAssessment',
                },
                null,
              ],
            },
            'Institutional Risk Assessment',
          ],
          'Add Institutional Risk Assessment',
        ],
      },
      type: 'questions',
      content: {
        '{}': {
          onSave: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'isReadonly',
                    },
                    true,
                  ],
                },
                null,
              ],
              {
                '{}': {
                  action: {
                    '{}': {
                      alias: 'sr.actions.save-risk-assessment',
                    },
                  },
                  variables: {
                    '{}': {
                      orgIdcRate: '${field:orgIdcRate}',
                      subrCoiExp: '${field:subrCoiExp}',
                      orgCoiPolicy: '${field:orgCoiPolicy}',
                      orgDebarSusp: '${field:orgDebarSusp}',
                      subrIdcAgree: '${field:subrIdcAgree}',
                      subrAuditDone: '${field:subrAuditDone}',
                      orgDelinFdDebt: '${field:orgDelinFdDebt}',
                      subrecipientId: {
                        '@$': 'subrecipientId',
                      },
                      orgCostProcsFam: '${field:orgCostProcsFam}',
                      orgProcSysCompl: '${field:orgProcSysCompl}',
                      orgAcctSysMature: '${field:orgAcctSysMature}',
                      orgInternalCtrls: '${field:orgInternalCtrls}',
                    },
                  },
                },
              },
            ],
          },
          sections: {
            '[]': [
              {
                '{}': {
                  name: 'Context questions (not scored)',
                  fields: {
                    '[]': [
                      {
                        '{}': {
                          id: 'orgDebarSusp',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!org_debar_susp',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'orgDebarSusp',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'orgDelinFdDebt',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!org_delin_fd_debt',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'orgDelinFdDebt',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'orgCoiPolicy',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!org_coi_policy',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'orgCoiPolicy',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'orgAcctSysMature',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!org_acct_sys_mature',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'orgAcctSysMature',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'orgCostProcsFam',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!org_cost_procs_fam',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'orgCostProcsFam',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'orgInternalCtrls',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!org_internal_ctrls',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'orgInternalCtrls',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'orgProcSysCompl',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!org_proc_sys_compl',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'orgProcSysCompl',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'orgIdcRate',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!org_idc_rate',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'orgIdcRate',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'subrAuditDone',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!subr_audit_done',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'subrAuditDone',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Risk survey',
                  fields: {
                    '[]': [
                      {
                        '{}': {
                          id: 'subrIdcAgree',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!subr_idc_agree',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'subrIdcAgree',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'subrCoiExp',
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:snap#!subrecips#!subrecipient_risk_survey:!subr_coi_exp',
                                },
                              },
                            },
                          },
                          value: {
                            '@>': [
                              {
                                '@': 'previewRiskAssessment',
                              },
                              'subrCoiExp',
                            ],
                          },
                          readonly: {
                            '@$': 'isReadonly',
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
        },
      },
    },
  },
  subqueries: {
    previewRiskAssessment: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'assessmentId',
          },
        ],
      },
      target: 'snap:!subrecips:!subrecipient_risk_survey',
      quantity: 1,
      selection: {
        '{}': {
          orgIdcRate: {
            '@.': '!org_idc_rate',
          },
          subrCoiExp: {
            '@.': '!subr_coi_exp',
          },
          orgCoiPolicy: {
            '@.': '!org_coi_policy',
          },
          orgDebarSusp: {
            '@.': '!org_debar_susp',
          },
          subrIdcAgree: {
            '@.': '!subr_idc_agree',
          },
          subrAuditDone: {
            '@.': '!subr_audit_done',
          },
          orgDelinFdDebt: {
            '@.': '!org_delin_fd_debt',
          },
          orgCostProcsFam: {
            '@.': '!org_cost_procs_fam',
          },
          orgProcSysCompl: {
            '@.': '!org_proc_sys_compl',
          },
          orgAcctSysMature: {
            '@.': '!org_acct_sys_mature',
          },
          orgInternalCtrls: {
            '@.': '!org_internal_ctrls',
          },
        },
      },
    },
  },
}
